import { DepartmentDto } from "../../autogen/bff-api";

export const defaultDepartment = (org: { departments: DepartmentDto[] }): DepartmentDto | undefined =>
  org.departments.find((d) => d.isDefault) ?? org.departments[0];

export const defaultDepartmentId = (org: { departments: DepartmentDto[] }): string => {
  const department = defaultDepartment(org);
  if (!department) throw new Error("Organization has no departments");
  return department.id;
};
